// extracted by mini-css-extract-plugin
module.exports = {"tip":"search-SearchTip__tip--1hmz5","tipCloseButton":"search-SearchTip__tipCloseButton--1uWaB"};